<template>
  <div :class="$style.fullHeight">
    <LoadingOverlay
      v-if="showLoader"
      :hasBlur="false"
      :isLight="true"
      visible
    />
    <div
      v-else
      :class="$style.fullHeight"
    >
      <HeadingSmall :class="$style.header">
        <div>
          <img
            :class="$style.img"
            :height="46"
            :src="getAppIcon"
            :width="46"
          >
        </div>
        <div :class="$style.imgText">
          {{ displayName }}
        </div>
      </HeadingSmall>
      <TabBar :class="$style.noBorder">
        <template v-slot:tabs>
          <Tabs
            :activeTab="activeTab"
            :tabs="$options.tabList"
            @selectedTab="handleSelectedTab"
          />
        </template>
      </TabBar>
      <div
        v-if="activeTab === 'details'"
      >
        <GoogleAppsDetailsPanel />
      </div>
      <div v-if="activeTab === 'device'">
        <GoogleAppsDevice />
      </div>
      <div v-if="activeTab === 'deviceGroup'">
        <GoogleAppsDeviceGroup />
      </div>
      <div v-if="activeTab === 'status'">
        <GoogleAppsStatus />
      </div>
    </div>
  </div>
</template>

<script>
import {
  HeadingSmall,
  LoadingOverlay,
  TabBar,
  Tabs,
  Types,
} from '@jumpcloud/ui-components';
import { ItemTypeConsts, StoreModelMap } from 'client/util/Constants';
import { mapActions, mapState } from 'vuex';
import GoogleAppsDetailsPanel from 'client/SoftwareApps/GoogleAppsDetailsPanel.vue';
import GoogleAppsDevice from 'client/SoftwareApps/GoogleAppsDevice.vue';
import GoogleAppsDeviceGroup from 'client/SoftwareApps/GoogleAppsDeviceGroup.vue';
import GoogleAppsStatus from 'client/SoftwareApps/GoogleAppsStatus.vue';

const { TabItem } = Types;
const softwareAppsModel = StoreModelMap[ItemTypeConsts.softwareApps];

const tabList = [
  TabItem({
    label: 'Details',
    key: 'details',
  }),
  TabItem({
    label: 'Device Group',
    key: 'deviceGroup',
  }),
  TabItem({
    label: 'Device',
    key: 'device',
  }),
  TabItem({
    label: 'Status',
    key: 'status',
  }),
];

export default {
  name: 'GoogleAppsDetailsMainPanel',

  components: {
    GoogleAppsDetailsPanel,
    GoogleAppsDevice,
    GoogleAppsDeviceGroup,
    GoogleAppsStatus,
    HeadingSmall,
    LoadingOverlay,
    TabBar,
    Tabs,
  },

  tabList,

  data: () => ({
    activeTab: tabList[0].key,
    showLoader: true,
    displayName: '',
  }),

  computed: {
    ...mapState(softwareAppsModel, [
      'item',
    ]),

    getAppIcon() {
      return this.item.settings[0].googleAndroid.iconUrl;
    },
  },

  mounted() {
    this.handleMounted();
  },

  methods: {
    ...mapActions(softwareAppsModel, [
      'fetchItem',
      'setItemField',
    ]),

    async handleMounted() {
      try {
        const str = window.location.href;
        const urlSplitList = str.split('/');
        this.setItemField({ key: 'id', value: urlSplitList[6] });
        await this.fetchItem();
        this.displayName = this.item.displayName;
        this.showLoader = false;
      } catch (error) {
        this.showLoader = true;
      }
    },

    handleSelectedTab(tabKey) {
      this.activeTab = tabKey;
    },
  },
};
</script>

<style module scoped>
.header {
  border-bottom: var(--jc-border);
  display: grid;
  grid-template-columns: 4.5rem auto;
  margin-bottom: 0 !important;
  padding-bottom: var(--jc-spacer-small);
  padding-left: 1.25rem;
  padding-top: 0.75rem;
}

.noBorder {
  border-bottom: none;
  margin-left: var(--jc-spacer-medium);
}

.fullHeight {
  height: 100%;
}

.img {
  border-radius: var(--jc-spacer-small);
}

.imgText {
  margin-bottom: auto;
  margin-top: auto;
}
</style>
